/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Form_DescriptionInputs */



/**
* | output |
* | --- |
* | "A space holds one credential for this API. Everyone who may use the space calls the API with it, so a person who needs their own key gets a space of their own." |
*
* @param {External_Apis_Space_Form_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_form_description = /** @type {((inputs?: External_Apis_Space_Form_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Form_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Space enthält eine Zugangsberechtigung für diese API. Alle, die den Space nutzen dürfen, rufen die API damit auf – wer einen eigenen Schlüssel braucht, bekommt also einen eigenen Space.")
	return /** @type {LocalizedString} */ ("A space holds one credential for this API. Everyone who may use the space calls the API with it, so a person who needs their own key gets a space of their own.")
});